import React from 'react'

import { connect } from 'react-redux'
import { Redirect, Switch } from 'react-router-dom'

import * as UserSelectors from 'modules/user/selectors'
import { ProtectedRoute } from 'utils'

import { getDefaultPath, PAGES, RESTRICTED_PATH } from '../settings'

const SettingsContent = (props) => (
  <Switch>
    {PAGES.map((page, index) => (
      <ProtectedRoute
        key={index}
        redirectPath={RESTRICTED_PATH}
        {...props}
        {...page}
      />
    ))}
    <Redirect from="/" to={getDefaultPath()} />
  </Switch>
)

const mapStateToProps = (state) => ({
  appConfig: UserSelectors.appConfig(state),
})

export default connect(mapStateToProps)(SettingsContent)
